import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CommonNotificationObject } from '../types';
import { INotificationAttrs } from '../../AppComponents/Notifications/types';

interface IAddCCAPINotificationsState extends Record<string, any> {
  notificationAttrs: INotificationAttrs;
  notification: CommonNotificationObject;
}

export const initialState: IAddCCAPINotificationsState = {
  notification: {},
  notificationAttrs: {} as INotificationAttrs,
};

const addCCAPINotificationsSlice = createSlice({
  name: 'addCCAPINotifications',
  initialState,
  reducers: {
    changeAddCCAPINotification(
      state,
      action: PayloadAction<CommonNotificationObject>,
    ) {
      state.notification = action.payload;

      if (Object.keys(state.notificationAttrs).length <= 0) {
        state.notificationAttrs = {
          mainLoad: 0,
          failed: false,
          fullyComplete: false,
        };
      }
    },
    changeAddCCAPINotificationAttrs(
      state,
      action: PayloadAction<Record<keyof INotificationAttrs, any>>,
    ) {
      state.notificationAttrs = {
        ...state.notificationAttrs,
        ...action.payload,
      };
    },
    clearAddCCAPINotifications() {
      return initialState;
    },
  },
});

export const {
  changeAddCCAPINotification,
  clearAddCCAPINotifications,
  changeAddCCAPINotificationAttrs,
} = addCCAPINotificationsSlice.actions;

export default addCCAPINotificationsSlice.reducer;
